'use client';
import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts';

const DATA = [
  { dept: 'CS & Eng', count: 182, color: '#1a2e5a' },
  { dept: 'Business', count: 154, color: '#243668' },
  { dept: 'Law', count: 98, color: '#2e4280' },
  { dept: 'Psychology', count: 87, color: '#c9a84c' },
  { dept: 'Finance', count: 76, color: '#d4b05e' },
  { dept: 'Architecture', count: 65, color: '#dfc070' },
  { dept: 'Electrical Eng', count: 58, color: '#8892a8' },
  { dept: 'Public Health', count: 52, color: '#a0a9bc' },
  { dept: 'Tourism', count: 47, color: '#b8bfce' },
  { dept: 'Euro Studies', count: 28, color: '#c8cdd8' },
];

const CustomTooltip = ({ active, payload }: { active?: boolean; payload?: { payload: { dept: string; count: number } }[] }) => {
  if (!active || !payload?.[0]) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-white border border-[#e2e6f0] rounded-xl shadow-lg p-3 text-xs">
      <p className="font-700 text-[#0f1a35] mb-1">{d.dept}</p>
      <p className="text-[#4a5578]">Published theses: <span className="font-700 text-[#1a2e5a]">{d.count}</span></p>
    </div>
  );
};

export default function SubmissionsByDepartmentChart() {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={DATA} margin={{ top: 5, right: 10, left: -15, bottom: 40 }} barSize={22}>
        <CartesianGrid stroke="#e2e6f0" strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="dept"
          tick={{ fontSize: 10, fill: '#8892a8' }}
          axisLine={false}
          tickLine={false}
          angle={-35}
          textAnchor="end"
          interval={0}
        />
        <YAxis tick={{ fontSize: 11, fill: '#8892a8' }} axisLine={false} tickLine={false} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="count" radius={[4, 4, 0, 0]}>
          {DATA.map((entry, i) => (
            <Cell key={`cell-dept-${i}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}